import { PersonContactData } from '../types/TymbeApi';
import { ContactType } from './enums';

export const getLatestPhone = (contacts?: PersonContactData[]) =>
  contacts
    ?.filter((c) => c.type === ContactType.MOBILE_PHONE && !c.deleted_at)
    ?.sort((a, b) =>
      new Date(b.updated_at ?? 0).getTime() - new Date(a.updated_at ?? 0).getTime(),
    )?.[0];

export const addPlusToPhone = (phone: string | null | undefined) => {
  if (phone) {
    return phone.replace('00', '+');
  }
  return undefined;
};

export const addZerosToPhone = (phone: string | null | undefined) => {
  if (phone) {
    return phone.replace('+', '00');
  }
  return undefined;
};
